// extracted by mini-css-extract-plugin
export default {"page":"ulxK6ZwyiiYcsO9E","container":"RBQr1ZQlrf0yZ0a4"};